<template>
  <div>
    <!-- <v-radio-group v-model="defaultSelected" @change="onClickPaymentMethod" row class="mt-0 pt-0" hide-details>
			<v-radio color="primary" value="add_card">
				<template slot="label">
					<span class="body-1">Credit/debit card</span>
				</template>
			</v-radio>
			<v-radio color="primary" value="bank_transfer">
				<template slot="label">
					<span class="body-1">Bank transfer</span>
				</template>
			</v-radio>
		</v-radio-group> -->

    <v-radio-group v-model="defaultSelected" @change="onClickPaymentMethod" hide-details>
      <v-radio color="primary" value="add_card" :class="{ 'new-radio': newUI }">
        <template slot="label">
          <v-icon color="grey darken-1">credit_card</v-icon>
          <span class="select-text">{{
            this.$t("$onboarding.content_paragraph.payment.summary.mode_of_payment.selection.card")
          }}</span>
        </template>
      </v-radio>
      <v-radio color="primary" value="bank_transfer" :class="{ 'new-radio': newUI }">
        <template slot="label">
          <v-icon color="grey darken-1">account_balance</v-icon
          ><span class="select-text">
            {{ this.$t("$onboarding.content_paragraph.payment.summary.mode_of_payment.selection.bank") }}</span
          >
        </template>
      </v-radio>
      <v-radio color="primary" value="pay_now" :class="{ 'new-radio': newUI }">
        <template slot="label">
          <img src="/imgs/payment/paynow-logo.svg" alt="PAYNOW" valign="middle" />
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
// Mappings
import { Constants } from "customer-sdk/constants";

const PAYMENT_METHODS_EVENTS = Constants.ON_BOARDING_PAYMENT_METHODS_EVENTS;

//#region private methods
let publishBankTransferSelected = component => {
  let { paymentMethodsTopic } = component;
  if (paymentMethodsTopic) {
    paymentMethodsTopic.publish({
      type: PAYMENT_METHODS_EVENTS.ON_BANK_TRANSFER_CLICKED,
      data: { selectedCard: "bank_transfer" }
    });
  }
};
let publishCardSelected = component => {
  console.log("publishCardSelected");
  let { paymentMethodsTopic } = component;
  if (paymentMethodsTopic) {
    paymentMethodsTopic.publish({
      type: PAYMENT_METHODS_EVENTS.ON_ADD_NEW_CARD_SELECTED,
      data: { selectedCard: "add_card" }
    });
  }
};
//#endregion

export default {
  methods: {
    onClickPaymentMethod: function() {
      console.log(this.defaultSelected);

      this.$emit("paymentMethodChange", this.defaultSelected);

      if (this.defaultSelected == "bank_transfer") {
        publishBankTransferSelected(this);
      } else {
        publishCardSelected(this);
      }
    }
  },
  props: {
    paymentMethodsTopic: Object,
    paymentMethodSelected: {
      default: "add_card",
      type: String
    },
    paymentMethodChange: Function,
    newUI: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      defaultSelected: this.paymentMethodSelected
    };
  }
};
</script>
